<template>
    <div class="sampleTable">
        <ATable
          :data="records"            
          :default-sort="{prop: 'code', order: 'descending'}" 
          hide-pagination
          exportName="임시"
          @clickSearch="clickSearch" @clickCreate="clickCreate">
          <el-table-column type="index" width="50" />
          <el-table-column prop="type" label="타입" width="80" />
          <el-table-column prop="code" label="코드" width="80" sortable />
          <el-table-column prop="name" label="거래처" sortable />
          <el-table-column prop="location" label="사업장" width="120" />
          <el-table-column prop="owner" label="대표자" width="80" />
          <el-table-column prop="hp" label="연락처" width="120" />          
          <el-table-column prop="description" label="비고" />
          <el-table-column
            label="이력"
            width="80"
          >
            <template slot-scope="scope">
              <el-popover    
                placement="bottom"
                trigger="click"
                title="Sure？"
                :content="scope.row.name"
              >
                <el-button slot="reference">이력</el-button>
              </el-popover>
            </template>
          </el-table-column>
          
        </ATable>
        <el-popover    
          placement="bottom"
          trigger="manual"
          title="Sure？"
          v-model="showDialog"
        >
          <el-button type="text" size="mini" @click="showDialog=false">Cancel</el-button>
          <el-button type="primary" size="mini" @click="showDialog=false">Sure</el-button>
          <el-button slot="reference" @click="showDialog=true">이력</el-button>
        </el-popover>
    </div>
</template>

<script>
export default {  
  name: 'sampleTable',
  data() {
    return {
      records: [        
        {id: 2, "type": "매입처", code: 2128, name: '(주)알루원', location: '성곡동', owner: '정구용', hp: '010-6244-6600', description: ''},
        {id: 1, "type": "매출처", code: 207, name: '', location: '문정동', owner: '송선숙', hp: '010-5576-8167', description: ''},
        {id: 3, "type": "매입처", code: 2028, name: '(주)경일알미늄', location: '신원로91번길', owner: '이영일', hp: '010-7537-0115', description: '010-9179-7512/선경박차장'}
      ],
      showDialog: false,
    };
  },
  methods: {    
    clickCreate() {
      console.error('clickCreate');
    },
    clickSearch(searchWord) {
      console.error('clickSearch', searchWord);
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
</style>
